import { render, staticRenderFns } from "./tabCard.vue?vue&type=template&id=6fcd14fd&scoped=true"
import script from "./tabCard.vue?vue&type=script&lang=js"
export * from "./tabCard.vue?vue&type=script&lang=js"
import style0 from "./tabCard.vue?vue&type=style&index=0&id=6fcd14fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fcd14fd",
  null
  
)

export default component.exports